import { FC } from "react"
import { Dialog } from 'primereact/dialog';
import './editmodaldialog.css'
import { Button } from "primereact/button";
import { MdEdit, MdOutlineCancel } from "react-icons/md";
import { InputNumber } from "primereact/inputnumber";
import { HiOutlinePencilSquare } from "react-icons/hi2";

export const EditModalDialog:FC<any> = (props):JSX.Element => {

    const { data, setData, dataMASTER, visible, selectedCell, selectedRow, setSelectedRow, handleClose, mode, type } = props 

    const handleUpdateDataProvider = () => {
        let original = dataMASTER.provider_table.find((ori:any) => ori.id_provider === selectedRow.id_provider)?.[selectedCell]
        let aux = data?.provider_table

        let provider_table = aux.map((a:any) => {
            if(a.id_provider === selectedRow?.id_provider) {
                return {...selectedRow, edited: original != selectedRow?.[selectedCell]? true : false}
            }
            return a
        })
        
        setData({...data,provider_table:provider_table})
        handleClose()
    }

    const handleUpdateDataContract = () => {
        let original = dataMASTER.contract_table.find((ori:any) => `${ori.name_provider}${ori.name_contract}` === `${selectedRow.name_provider}${selectedRow.name_contract}`)?.[selectedCell]
        let aux = data?.contract_table

        let contract_table = aux.map((a:any) => {
            if(`${a.name_provider}${a.name_contract}` === `${selectedRow?.name_provider}${selectedRow?.name_contract}`) {
                return {...selectedRow, edited: original != selectedRow?.[selectedCell]? true : false}
            }
            return a
        })
        
        setData({...data,contract_table:contract_table})
        handleClose()
    }

    const renderLabel = () => {
        let field_array = selectedCell?.split("_")
        field_array?.pop()
        
        let header_title = field_array?.map((word:string,index:number) => {
            if(index === 0) {
                return word.charAt(0).toUpperCase() + word.slice(1)
            }
            return word
        }).join(' ')

        return header_title
    }

    const header = () => {
        return (
            <span>Ajuste de parámetros</span>
        )
    }

    const footer = () => {
        return (
            <div className="scenarios-footer">
                <Button severity={'success'} label="Actualizar" icon={<MdEdit style={{fontSize:20}} />}  onClick={type === "P"? handleUpdateDataProvider : handleUpdateDataContract} outlined  />
                <Button severity={'danger'} label="Cancelar" icon={<MdOutlineCancel style={{fontSize:20,marginRight:5}} />}  outlined onClick={handleClose} />
            </div>
        )
    }

    const handleChangeValue = (e:any) => {
        const { value } = e
        setSelectedRow({...selectedRow,[selectedCell]:parseFloat(value)})
    }

    return (
        <div className="card flex justify-content-center">
            <Dialog className={mode === 'base'? "edit-modal-dialog-base" : mode === 'comparision' ? "edit-modal-dialog-compare" : "edit-modal-dialog-neutral"} header={header} visible={visible} style={{ width: '25vw' }} footer={footer} onHide={handleClose}>
                <div style={{minHeight:85,display:'flex',justifyContent:'center',alignItems:'center',padding:'1rem'}}>
                    <div className="card flex justify-content-center" style={{width:'95%'}}>
                        <label style={{fontFamily: 'var(--roboto-heavy)'}} htmlFor={"error-name"}>{renderLabel()}</label>
                        <div className="permisos__header-input">
                            <InputNumber id={"error-name"} className="scenario-inputs" style={{width:'100%'}} onChange={handleChangeValue} inputMode="decimal" minFractionDigits={2}  value={selectedRow?.[selectedCell] ?? 0 }    />

                            <span className="p-inputgroup-addon" >
                                <HiOutlinePencilSquare style={{fontSize:20}} />
                            </span>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}